import useLoading from '@hooks/ui/useLoading';
import useProject from '@hooks/useProject';

const appleRedirectUri = import.meta.env.VITE_APPLE_REDIRECT_URI;

function useSignInWIthApple() {
    const project = useProject();
    const { startLoading, stopLoading } = useLoading();
    const appleClientId = project?.appleClientId;
    const isIos = !(navigator.userAgent.match(/iPhone|iPad|iPod/i) === null);

    const handleAppleSignIn = () => {
        startLoading();
        const timeout = setTimeout(() => {
            stopLoading();
            clearTimeout(timeout);
        }, 1500);
        const url = `https://appleid.apple.com/auth/authorize
?response_type=code
&client_id=${appleClientId}
&redirect_uri=${appleRedirectUri}
&response_mode=query`;
        window.open(url, '_self');
        return () => clearTimeout(timeout);
    };

    return {
        handleAppleSignIn, isIos, appleClientId,
    };
}

export default useSignInWIthApple;
